import { SVGProps, Ref, forwardRef, memo } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <g clipPath="url(#clip0_1044_2816)">
      <path
        d="M0.822464 8.8011C0.954578 10.036 1.94775 11.0292 3.182 11.1667C5.07782 11.378 6.92161 11.378 8.81741 11.1667C10.0517 11.0292 11.0449 10.036 11.177 8.8011C11.2745 7.88952 11.3569 6.95364 11.3569 5.9995C11.3569 5.04537 11.2745 4.10949 11.177 3.19792C11.0449 1.96307 10.0517 0.969892 8.81741 0.832316C6.92161 0.620999 5.07782 0.620999 3.182 0.832316C1.94775 0.969892 0.954578 1.96307 0.822464 3.19792C0.724935 4.10949 0.642578 5.04537 0.642578 5.9995C0.642578 6.95364 0.724936 7.88952 0.822464 8.8011Z"
        fill="white"
        stroke="#2C7152"
      />
      <path d="M7.51484 4.48438L4.48438 7.51483" stroke="#2C7152" strokeLinecap="round" />
      <path d="M7.51484 7.51483L4.48438 4.48438" stroke="#2C7152" strokeLinecap="round" />
    </g>
    <defs>
      <clipPath id="clip0_1044_2816">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const ForwardRef = forwardRef(SvgComponent);
const DeleteFile = memo(ForwardRef);
export default DeleteFile;
